/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PilotEndedRouteImport } from './routes/pilot-ended'
import { Route as StopImpersonatingRouteImport } from './routes/stop-impersonating'
import { Route as UnavailableRouteImport } from './routes/unavailable'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSplatRouteImport } from './routes/_app/$'
import { Route as AppContactsRouteImport } from './routes/_app/contacts'
import { Route as AppConversationsRouteImport } from './routes/_app/conversations'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AgendaproxyConsentRouteImport } from './routes/agendaproxy.consent'
import { Route as CheckCalendarRouteImport } from './routes/check.calendar'
import { Route as DemoStartRouteImport } from './routes/demo.start'
import { Route as OnboardingIndexRouteImport } from './routes/onboarding/index'
import { Route as OnboardingCalendarRouteImport } from './routes/onboarding/calendar'
import { Route as OnboardingColleaguesRouteImport } from './routes/onboarding/colleagues'
import { Route as OnboardingFirstMeetingRouteImport } from './routes/onboarding/first-meeting'
import { Route as OnboardingHowItWorksRouteImport } from './routes/onboarding/how-it-works'
import { Route as OnboardingReadyToPractiseRouteImport } from './routes/onboarding/ready-to-practise'
import { Route as OnboardingWelcomeRouteImport } from './routes/onboarding/welcome'
import { Route as OnboardingWhatYouGetRouteImport } from './routes/onboarding/what-you-get'
import { Route as SignInVerifyRouteImport } from './routes/sign-in.verify'
import { Route as AppJourneysIndexRouteImport } from './routes/_app/journeys/index'
import { Route as AppJourneysJourneyIdRouteImport } from './routes/_app/journeys/$journeyId'
import { Route as AppMeetingsIndexRouteImport } from './routes/_app/meetings/index'
import { Route as AppMeetingsMeetingIdRouteImport } from './routes/_app/meetings/$meetingId'
import { Route as AppPracticeIndexRouteImport } from './routes/_app/practice/index'
import { Route as AppPracticeNewRouteImport } from './routes/_app/practice/new'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAgendaRouteImport } from './routes/_app/settings/agenda'
import { Route as AppSettingsConnectionsRouteImport } from './routes/_app/settings/connections'
import { Route as AppSettingsMeetingsRouteImport } from './routes/_app/settings/meetings'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsProfileRouteImport } from './routes/_app/settings/profile'
import { Route as AppSettingsTemplatesRouteImport } from './routes/_app/settings/templates'
import { Route as AppTeamIndexRouteImport } from './routes/_app/team/index'
import { Route as AppTeamColleagueIdRouteImport } from './routes/_app/team/$colleagueId'
import { Route as PracticeSessionSessionIdRouteImport } from './routes/practice.session.$sessionId'
import { Route as AppPracticeRoleplayIdIndexRouteImport } from './routes/_app/practice/$roleplayId.index'
import { Route as AppPracticeRoleplayIdEditRouteImport } from './routes/_app/practice/$roleplayId.edit'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PilotEndedRoute = PilotEndedRouteImport.update({
  id: '/pilot-ended',
  path: '/pilot-ended',
  getParentRoute: () => rootRouteImport,
} as any)
const StopImpersonatingRoute = StopImpersonatingRouteImport.update({
  id: '/stop-impersonating',
  path: '/stop-impersonating',
  getParentRoute: () => rootRouteImport,
} as any)
const UnavailableRoute = UnavailableRouteImport.update({
  id: '/unavailable',
  path: '/unavailable',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppConversationsRoute = AppConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AgendaproxyConsentRoute = AgendaproxyConsentRouteImport.update({
  id: '/agendaproxy/consent',
  path: '/agendaproxy/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckCalendarRoute = CheckCalendarRouteImport.update({
  id: '/check/calendar',
  path: '/check/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoStartRoute = DemoStartRouteImport.update({
  id: '/demo/start',
  path: '/demo/start',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingCalendarRoute = OnboardingCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingColleaguesRoute = OnboardingColleaguesRouteImport.update({
  id: '/colleagues',
  path: '/colleagues',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingFirstMeetingRoute = OnboardingFirstMeetingRouteImport.update({
  id: '/first-meeting',
  path: '/first-meeting',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingHowItWorksRoute = OnboardingHowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingReadyToPractiseRoute =
  OnboardingReadyToPractiseRouteImport.update({
    id: '/ready-to-practise',
    path: '/ready-to-practise',
    getParentRoute: () => OnboardingRoute,
  } as any)
const OnboardingWelcomeRoute = OnboardingWelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingWhatYouGetRoute = OnboardingWhatYouGetRouteImport.update({
  id: '/what-you-get',
  path: '/what-you-get',
  getParentRoute: () => OnboardingRoute,
} as any)
const SignInVerifyRoute = SignInVerifyRouteImport.update({
  id: '/sign-in/verify',
  path: '/sign-in/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AppJourneysIndexRoute = AppJourneysIndexRouteImport.update({
  id: '/journeys/',
  path: '/journeys/',
  getParentRoute: () => AppRoute,
} as any)
const AppJourneysJourneyIdRoute = AppJourneysJourneyIdRouteImport.update({
  id: '/journeys/$journeyId',
  path: '/journeys/$journeyId',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsIndexRoute = AppMeetingsIndexRouteImport.update({
  id: '/meetings/',
  path: '/meetings/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeetingsMeetingIdRoute = AppMeetingsMeetingIdRouteImport.update({
  id: '/meetings/$meetingId',
  path: '/meetings/$meetingId',
  getParentRoute: () => AppRoute,
} as any)
const AppPracticeIndexRoute = AppPracticeIndexRouteImport.update({
  id: '/practice/',
  path: '/practice/',
  getParentRoute: () => AppRoute,
} as any)
const AppPracticeNewRoute = AppPracticeNewRouteImport.update({
  id: '/practice/new',
  path: '/practice/new',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAgendaRoute = AppSettingsAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsConnectionsRoute = AppSettingsConnectionsRouteImport.update({
  id: '/connections',
  path: '/connections',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsMeetingsRoute = AppSettingsMeetingsRouteImport.update({
  id: '/meetings',
  path: '/meetings',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTemplatesRoute = AppSettingsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppTeamIndexRoute = AppTeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamColleagueIdRoute = AppTeamColleagueIdRouteImport.update({
  id: '/team/$colleagueId',
  path: '/team/$colleagueId',
  getParentRoute: () => AppRoute,
} as any)
const PracticeSessionSessionIdRoute =
  PracticeSessionSessionIdRouteImport.update({
    id: '/practice/session/$sessionId',
    path: '/practice/session/$sessionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AppPracticeRoleplayIdIndexRoute =
  AppPracticeRoleplayIdIndexRouteImport.update({
    id: '/practice/$roleplayId/',
    path: '/practice/$roleplayId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPracticeRoleplayIdEditRoute =
  AppPracticeRoleplayIdEditRouteImport.update({
    id: '/practice/$roleplayId/edit',
    path: '/practice/$roleplayId/edit',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/pilot-ended': typeof PilotEndedRoute
  '/stop-impersonating': typeof StopImpersonatingRoute
  '/unavailable': typeof UnavailableRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/$': typeof AppSplatRoute
  '/contacts': typeof AppContactsRoute
  '/conversations': typeof AppConversationsRoute
  '/dashboard': typeof AppDashboardRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/agendaproxy/consent': typeof AgendaproxyConsentRoute
  '/check/calendar': typeof CheckCalendarRoute
  '/demo/start': typeof DemoStartRoute
  '/onboarding/calendar': typeof OnboardingCalendarRoute
  '/onboarding/colleagues': typeof OnboardingColleaguesRoute
  '/onboarding/first-meeting': typeof OnboardingFirstMeetingRoute
  '/onboarding/how-it-works': typeof OnboardingHowItWorksRoute
  '/onboarding/ready-to-practise': typeof OnboardingReadyToPractiseRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/onboarding/what-you-get': typeof OnboardingWhatYouGetRoute
  '/sign-in/verify': typeof SignInVerifyRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/journeys/$journeyId': typeof AppJourneysJourneyIdRoute
  '/meetings/$meetingId': typeof AppMeetingsMeetingIdRoute
  '/practice/new': typeof AppPracticeNewRoute
  '/settings/agenda': typeof AppSettingsAgendaRoute
  '/settings/connections': typeof AppSettingsConnectionsRoute
  '/settings/meetings': typeof AppSettingsMeetingsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/team/$colleagueId': typeof AppTeamColleagueIdRoute
  '/practice/session/$sessionId': typeof PracticeSessionSessionIdRoute
  '/journeys/': typeof AppJourneysIndexRoute
  '/meetings/': typeof AppMeetingsIndexRoute
  '/practice/': typeof AppPracticeIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/team/': typeof AppTeamIndexRoute
  '/practice/$roleplayId/edit': typeof AppPracticeRoleplayIdEditRoute
  '/practice/$roleplayId/': typeof AppPracticeRoleplayIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/pilot-ended': typeof PilotEndedRoute
  '/stop-impersonating': typeof StopImpersonatingRoute
  '/unavailable': typeof UnavailableRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/$': typeof AppSplatRoute
  '/contacts': typeof AppContactsRoute
  '/conversations': typeof AppConversationsRoute
  '/dashboard': typeof AppDashboardRoute
  '/agendaproxy/consent': typeof AgendaproxyConsentRoute
  '/check/calendar': typeof CheckCalendarRoute
  '/demo/start': typeof DemoStartRoute
  '/onboarding/calendar': typeof OnboardingCalendarRoute
  '/onboarding/colleagues': typeof OnboardingColleaguesRoute
  '/onboarding/first-meeting': typeof OnboardingFirstMeetingRoute
  '/onboarding/how-it-works': typeof OnboardingHowItWorksRoute
  '/onboarding/ready-to-practise': typeof OnboardingReadyToPractiseRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/onboarding/what-you-get': typeof OnboardingWhatYouGetRoute
  '/sign-in/verify': typeof SignInVerifyRoute
  '/': typeof AppIndexRoute
  '/onboarding': typeof OnboardingIndexRoute
  '/journeys/$journeyId': typeof AppJourneysJourneyIdRoute
  '/meetings/$meetingId': typeof AppMeetingsMeetingIdRoute
  '/practice/new': typeof AppPracticeNewRoute
  '/settings/agenda': typeof AppSettingsAgendaRoute
  '/settings/connections': typeof AppSettingsConnectionsRoute
  '/settings/meetings': typeof AppSettingsMeetingsRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/profile': typeof AppSettingsProfileRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/team/$colleagueId': typeof AppTeamColleagueIdRoute
  '/practice/session/$sessionId': typeof PracticeSessionSessionIdRoute
  '/journeys': typeof AppJourneysIndexRoute
  '/meetings': typeof AppMeetingsIndexRoute
  '/practice': typeof AppPracticeIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/team': typeof AppTeamIndexRoute
  '/practice/$roleplayId/edit': typeof AppPracticeRoleplayIdEditRoute
  '/practice/$roleplayId': typeof AppPracticeRoleplayIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/pilot-ended': typeof PilotEndedRoute
  '/stop-impersonating': typeof StopImpersonatingRoute
  '/unavailable': typeof UnavailableRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/_app/$': typeof AppSplatRoute
  '/_app/contacts': typeof AppContactsRoute
  '/_app/conversations': typeof AppConversationsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/agendaproxy/consent': typeof AgendaproxyConsentRoute
  '/check/calendar': typeof CheckCalendarRoute
  '/demo/start': typeof DemoStartRoute
  '/onboarding/calendar': typeof OnboardingCalendarRoute
  '/onboarding/colleagues': typeof OnboardingColleaguesRoute
  '/onboarding/first-meeting': typeof OnboardingFirstMeetingRoute
  '/onboarding/how-it-works': typeof OnboardingHowItWorksRoute
  '/onboarding/ready-to-practise': typeof OnboardingReadyToPractiseRoute
  '/onboarding/welcome': typeof OnboardingWelcomeRoute
  '/onboarding/what-you-get': typeof OnboardingWhatYouGetRoute
  '/sign-in/verify': typeof SignInVerifyRoute
  '/_app/': typeof AppIndexRoute
  '/onboarding/': typeof OnboardingIndexRoute
  '/_app/journeys/$journeyId': typeof AppJourneysJourneyIdRoute
  '/_app/meetings/$meetingId': typeof AppMeetingsMeetingIdRoute
  '/_app/practice/new': typeof AppPracticeNewRoute
  '/_app/settings/agenda': typeof AppSettingsAgendaRoute
  '/_app/settings/connections': typeof AppSettingsConnectionsRoute
  '/_app/settings/meetings': typeof AppSettingsMeetingsRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/profile': typeof AppSettingsProfileRoute
  '/_app/settings/templates': typeof AppSettingsTemplatesRoute
  '/_app/team/$colleagueId': typeof AppTeamColleagueIdRoute
  '/practice/session/$sessionId': typeof PracticeSessionSessionIdRoute
  '/_app/journeys/': typeof AppJourneysIndexRoute
  '/_app/meetings/': typeof AppMeetingsIndexRoute
  '/_app/practice/': typeof AppPracticeIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/team/': typeof AppTeamIndexRoute
  '/_app/practice/$roleplayId/edit': typeof AppPracticeRoleplayIdEditRoute
  '/_app/practice/$roleplayId/': typeof AppPracticeRoleplayIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/logout'
    | '/onboarding'
    | '/pilot-ended'
    | '/stop-impersonating'
    | '/unavailable'
    | '/unsubscribe'
    | '/$'
    | '/contacts'
    | '/conversations'
    | '/dashboard'
    | '/settings'
    | '/agendaproxy/consent'
    | '/check/calendar'
    | '/demo/start'
    | '/onboarding/calendar'
    | '/onboarding/colleagues'
    | '/onboarding/first-meeting'
    | '/onboarding/how-it-works'
    | '/onboarding/ready-to-practise'
    | '/onboarding/welcome'
    | '/onboarding/what-you-get'
    | '/sign-in/verify'
    | '/onboarding/'
    | '/journeys/$journeyId'
    | '/meetings/$meetingId'
    | '/practice/new'
    | '/settings/agenda'
    | '/settings/connections'
    | '/settings/meetings'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/templates'
    | '/team/$colleagueId'
    | '/practice/session/$sessionId'
    | '/journeys/'
    | '/meetings/'
    | '/practice/'
    | '/settings/'
    | '/team/'
    | '/practice/$roleplayId/edit'
    | '/practice/$roleplayId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/logout'
    | '/pilot-ended'
    | '/stop-impersonating'
    | '/unavailable'
    | '/unsubscribe'
    | '/$'
    | '/contacts'
    | '/conversations'
    | '/dashboard'
    | '/agendaproxy/consent'
    | '/check/calendar'
    | '/demo/start'
    | '/onboarding/calendar'
    | '/onboarding/colleagues'
    | '/onboarding/first-meeting'
    | '/onboarding/how-it-works'
    | '/onboarding/ready-to-practise'
    | '/onboarding/welcome'
    | '/onboarding/what-you-get'
    | '/sign-in/verify'
    | '/'
    | '/onboarding'
    | '/journeys/$journeyId'
    | '/meetings/$meetingId'
    | '/practice/new'
    | '/settings/agenda'
    | '/settings/connections'
    | '/settings/meetings'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/templates'
    | '/team/$colleagueId'
    | '/practice/session/$sessionId'
    | '/journeys'
    | '/meetings'
    | '/practice'
    | '/settings'
    | '/team'
    | '/practice/$roleplayId/edit'
    | '/practice/$roleplayId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/logout'
    | '/onboarding'
    | '/pilot-ended'
    | '/stop-impersonating'
    | '/unavailable'
    | '/unsubscribe'
    | '/_app/$'
    | '/_app/contacts'
    | '/_app/conversations'
    | '/_app/dashboard'
    | '/_app/settings'
    | '/agendaproxy/consent'
    | '/check/calendar'
    | '/demo/start'
    | '/onboarding/calendar'
    | '/onboarding/colleagues'
    | '/onboarding/first-meeting'
    | '/onboarding/how-it-works'
    | '/onboarding/ready-to-practise'
    | '/onboarding/welcome'
    | '/onboarding/what-you-get'
    | '/sign-in/verify'
    | '/_app/'
    | '/onboarding/'
    | '/_app/journeys/$journeyId'
    | '/_app/meetings/$meetingId'
    | '/_app/practice/new'
    | '/_app/settings/agenda'
    | '/_app/settings/connections'
    | '/_app/settings/meetings'
    | '/_app/settings/notifications'
    | '/_app/settings/profile'
    | '/_app/settings/templates'
    | '/_app/team/$colleagueId'
    | '/practice/session/$sessionId'
    | '/_app/journeys/'
    | '/_app/meetings/'
    | '/_app/practice/'
    | '/_app/settings/'
    | '/_app/team/'
    | '/_app/practice/$roleplayId/edit'
    | '/_app/practice/$roleplayId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PilotEndedRoute: typeof PilotEndedRoute
  StopImpersonatingRoute: typeof StopImpersonatingRoute
  UnavailableRoute: typeof UnavailableRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  AgendaproxyConsentRoute: typeof AgendaproxyConsentRoute
  CheckCalendarRoute: typeof CheckCalendarRoute
  DemoStartRoute: typeof DemoStartRoute
  SignInVerifyRoute: typeof SignInVerifyRoute
  PracticeSessionSessionIdRoute: typeof PracticeSessionSessionIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pilot-ended': {
      id: '/pilot-ended'
      path: '/pilot-ended'
      fullPath: '/pilot-ended'
      preLoaderRoute: typeof PilotEndedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stop-impersonating': {
      id: '/stop-impersonating'
      path: '/stop-impersonating'
      fullPath: '/stop-impersonating'
      preLoaderRoute: typeof StopImpersonatingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unavailable': {
      id: '/unavailable'
      path: '/unavailable'
      fullPath: '/unavailable'
      preLoaderRoute: typeof UnavailableRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/$': {
      id: '/_app/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts': {
      id: '/_app/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/conversations': {
      id: '/_app/conversations'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof AppConversationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/agendaproxy/consent': {
      id: '/agendaproxy/consent'
      path: '/agendaproxy/consent'
      fullPath: '/agendaproxy/consent'
      preLoaderRoute: typeof AgendaproxyConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check/calendar': {
      id: '/check/calendar'
      path: '/check/calendar'
      fullPath: '/check/calendar'
      preLoaderRoute: typeof CheckCalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo/start': {
      id: '/demo/start'
      path: '/demo/start'
      fullPath: '/demo/start'
      preLoaderRoute: typeof DemoStartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/': {
      id: '/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof OnboardingIndexRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/calendar': {
      id: '/onboarding/calendar'
      path: '/calendar'
      fullPath: '/onboarding/calendar'
      preLoaderRoute: typeof OnboardingCalendarRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/colleagues': {
      id: '/onboarding/colleagues'
      path: '/colleagues'
      fullPath: '/onboarding/colleagues'
      preLoaderRoute: typeof OnboardingColleaguesRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/first-meeting': {
      id: '/onboarding/first-meeting'
      path: '/first-meeting'
      fullPath: '/onboarding/first-meeting'
      preLoaderRoute: typeof OnboardingFirstMeetingRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/how-it-works': {
      id: '/onboarding/how-it-works'
      path: '/how-it-works'
      fullPath: '/onboarding/how-it-works'
      preLoaderRoute: typeof OnboardingHowItWorksRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/ready-to-practise': {
      id: '/onboarding/ready-to-practise'
      path: '/ready-to-practise'
      fullPath: '/onboarding/ready-to-practise'
      preLoaderRoute: typeof OnboardingReadyToPractiseRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/welcome': {
      id: '/onboarding/welcome'
      path: '/welcome'
      fullPath: '/onboarding/welcome'
      preLoaderRoute: typeof OnboardingWelcomeRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/what-you-get': {
      id: '/onboarding/what-you-get'
      path: '/what-you-get'
      fullPath: '/onboarding/what-you-get'
      preLoaderRoute: typeof OnboardingWhatYouGetRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/sign-in/verify': {
      id: '/sign-in/verify'
      path: '/sign-in/verify'
      fullPath: '/sign-in/verify'
      preLoaderRoute: typeof SignInVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/journeys/': {
      id: '/_app/journeys/'
      path: '/journeys'
      fullPath: '/journeys/'
      preLoaderRoute: typeof AppJourneysIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/journeys/$journeyId': {
      id: '/_app/journeys/$journeyId'
      path: '/journeys/$journeyId'
      fullPath: '/journeys/$journeyId'
      preLoaderRoute: typeof AppJourneysJourneyIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/': {
      id: '/_app/meetings/'
      path: '/meetings'
      fullPath: '/meetings/'
      preLoaderRoute: typeof AppMeetingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meetings/$meetingId': {
      id: '/_app/meetings/$meetingId'
      path: '/meetings/$meetingId'
      fullPath: '/meetings/$meetingId'
      preLoaderRoute: typeof AppMeetingsMeetingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/practice/': {
      id: '/_app/practice/'
      path: '/practice'
      fullPath: '/practice/'
      preLoaderRoute: typeof AppPracticeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/practice/new': {
      id: '/_app/practice/new'
      path: '/practice/new'
      fullPath: '/practice/new'
      preLoaderRoute: typeof AppPracticeNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/agenda': {
      id: '/_app/settings/agenda'
      path: '/agenda'
      fullPath: '/settings/agenda'
      preLoaderRoute: typeof AppSettingsAgendaRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/connections': {
      id: '/_app/settings/connections'
      path: '/connections'
      fullPath: '/settings/connections'
      preLoaderRoute: typeof AppSettingsConnectionsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/meetings': {
      id: '/_app/settings/meetings'
      path: '/meetings'
      fullPath: '/settings/meetings'
      preLoaderRoute: typeof AppSettingsMeetingsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/profile': {
      id: '/_app/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/templates': {
      id: '/_app/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof AppSettingsTemplatesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/team/': {
      id: '/_app/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof AppTeamIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team/$colleagueId': {
      id: '/_app/team/$colleagueId'
      path: '/team/$colleagueId'
      fullPath: '/team/$colleagueId'
      preLoaderRoute: typeof AppTeamColleagueIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/practice/session/$sessionId': {
      id: '/practice/session/$sessionId'
      path: '/practice/session/$sessionId'
      fullPath: '/practice/session/$sessionId'
      preLoaderRoute: typeof PracticeSessionSessionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/practice/$roleplayId/': {
      id: '/_app/practice/$roleplayId/'
      path: '/practice/$roleplayId'
      fullPath: '/practice/$roleplayId/'
      preLoaderRoute: typeof AppPracticeRoleplayIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/practice/$roleplayId/edit': {
      id: '/_app/practice/$roleplayId/edit'
      path: '/practice/$roleplayId/edit'
      fullPath: '/practice/$roleplayId/edit'
      preLoaderRoute: typeof AppPracticeRoleplayIdEditRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsAgendaRoute: typeof AppSettingsAgendaRoute
  AppSettingsConnectionsRoute: typeof AppSettingsConnectionsRoute
  AppSettingsMeetingsRoute: typeof AppSettingsMeetingsRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsTemplatesRoute: typeof AppSettingsTemplatesRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAgendaRoute: AppSettingsAgendaRoute,
  AppSettingsConnectionsRoute: AppSettingsConnectionsRoute,
  AppSettingsMeetingsRoute: AppSettingsMeetingsRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsTemplatesRoute: AppSettingsTemplatesRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppSplatRoute: typeof AppSplatRoute
  AppContactsRoute: typeof AppContactsRoute
  AppConversationsRoute: typeof AppConversationsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppJourneysJourneyIdRoute: typeof AppJourneysJourneyIdRoute
  AppMeetingsMeetingIdRoute: typeof AppMeetingsMeetingIdRoute
  AppPracticeNewRoute: typeof AppPracticeNewRoute
  AppTeamColleagueIdRoute: typeof AppTeamColleagueIdRoute
  AppJourneysIndexRoute: typeof AppJourneysIndexRoute
  AppMeetingsIndexRoute: typeof AppMeetingsIndexRoute
  AppPracticeIndexRoute: typeof AppPracticeIndexRoute
  AppTeamIndexRoute: typeof AppTeamIndexRoute
  AppPracticeRoleplayIdEditRoute: typeof AppPracticeRoleplayIdEditRoute
  AppPracticeRoleplayIdIndexRoute: typeof AppPracticeRoleplayIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSplatRoute: AppSplatRoute,
  AppContactsRoute: AppContactsRoute,
  AppConversationsRoute: AppConversationsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppJourneysJourneyIdRoute: AppJourneysJourneyIdRoute,
  AppMeetingsMeetingIdRoute: AppMeetingsMeetingIdRoute,
  AppPracticeNewRoute: AppPracticeNewRoute,
  AppTeamColleagueIdRoute: AppTeamColleagueIdRoute,
  AppJourneysIndexRoute: AppJourneysIndexRoute,
  AppMeetingsIndexRoute: AppMeetingsIndexRoute,
  AppPracticeIndexRoute: AppPracticeIndexRoute,
  AppTeamIndexRoute: AppTeamIndexRoute,
  AppPracticeRoleplayIdEditRoute: AppPracticeRoleplayIdEditRoute,
  AppPracticeRoleplayIdIndexRoute: AppPracticeRoleplayIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface OnboardingRouteChildren {
  OnboardingCalendarRoute: typeof OnboardingCalendarRoute
  OnboardingColleaguesRoute: typeof OnboardingColleaguesRoute
  OnboardingFirstMeetingRoute: typeof OnboardingFirstMeetingRoute
  OnboardingHowItWorksRoute: typeof OnboardingHowItWorksRoute
  OnboardingReadyToPractiseRoute: typeof OnboardingReadyToPractiseRoute
  OnboardingWelcomeRoute: typeof OnboardingWelcomeRoute
  OnboardingWhatYouGetRoute: typeof OnboardingWhatYouGetRoute
  OnboardingIndexRoute: typeof OnboardingIndexRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingCalendarRoute: OnboardingCalendarRoute,
  OnboardingColleaguesRoute: OnboardingColleaguesRoute,
  OnboardingFirstMeetingRoute: OnboardingFirstMeetingRoute,
  OnboardingHowItWorksRoute: OnboardingHowItWorksRoute,
  OnboardingReadyToPractiseRoute: OnboardingReadyToPractiseRoute,
  OnboardingWelcomeRoute: OnboardingWelcomeRoute,
  OnboardingWhatYouGetRoute: OnboardingWhatYouGetRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  PilotEndedRoute: PilotEndedRoute,
  StopImpersonatingRoute: StopImpersonatingRoute,
  UnavailableRoute: UnavailableRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  AgendaproxyConsentRoute: AgendaproxyConsentRoute,
  CheckCalendarRoute: CheckCalendarRoute,
  DemoStartRoute: DemoStartRoute,
  SignInVerifyRoute: SignInVerifyRoute,
  PracticeSessionSessionIdRoute: PracticeSessionSessionIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
